/* import __COLOCATED_TEMPLATE__ from './future-date-input-selector-header.hbs.js'; */
import { classNames } from "@ember-decorators/component";
import ComboBoxHeaderComponent from "select-kit/components/combo-box/combo-box-header";
const FutureDateInputSelectorHeader = dt7948.c(class FutureDateInputSelectorHeader extends ComboBoxHeaderComponent {}, [classNames("future-date-input-selector-header")]);
export default FutureDateInputSelectorHeader;